// const GOOGLE_PLACES_API_KEY = process.env.NEXT_PUBLIC_GMAPAPI;

// Alex Rodriguez Counselling, Life Coaching & Allied Health, Blacktown NSW
export const GOOGLE_PLACE_ID = "ChIJywsPPKJ3lwQR27wImwAK4Dk";
export const GOOGLE_MAPS_PLACE_URL = `https://www.google.com/maps/place/?q=place_id:${GOOGLE_PLACE_ID}`;

export interface GoogleReview {
  author: string;
  authorUrl: string;
  profilePhotoUrl: string;
  rating: number;
  text: string;
  relativeTime: string;
  time: number; // unix seconds
}

export interface GoogleReviewsData {
  rating: number;
  userRatingsTotal: number;
  reviews: GoogleReview[];
}

// Google Places Details only ever returns up to 5 reviews per place, even
// though `userRatingsTotal` reflects the true review count - that ceiling is
// enforced by Google, not something a request parameter can change.
export async function fetchGoogleReviews(): Promise<GoogleReviewsData | null> {
  if (!process.env.NEXT_PUBLIC_GMAPAPI) {
    console.error(
      "[googleReviews] NEXT_PUBLIC_GMAPAPI is not set in this environment",
    );
    return null;
  }

  const url = new URL(
    "https://maps.googleapis.com/maps/api/place/details/json",
  );
  url.searchParams.set("place_id", GOOGLE_PLACE_ID);
  url.searchParams.set("fields", "rating,user_ratings_total,reviews");
  url.searchParams.set("reviews_sort", "newest");
  url.searchParams.set("key", process.env.NEXT_PUBLIC_GMAPAPI);

  const res = await fetch(url.toString(), { next: { revalidate: 86400 } });
  if (!res.ok) {
    console.error(
      `[googleReviews] Places API request failed: HTTP ${res.status} ${res.statusText}`,
    );
    return null;
  }

  const data = await res.json();
  if (data.status !== "OK" || !data.result) {
    console.error(
      `[googleReviews] Places API returned status "${data.status}"${data.error_message ? `: ${data.error_message}` : ""}`,
    );
    return null;
  }

  return {
    rating: data.result.rating ?? 0,
    userRatingsTotal: data.result.user_ratings_total ?? 0,
    // Some Google reviews are rating-only (no written comment) - skip those,
    // there's nothing to show in a quote card.
    reviews: (data.result.reviews ?? [])
      .filter((r: any) => r.text && r.text.trim().length > 0)
      .map((r: any) => ({
        author: r.author_name,
        authorUrl: r.author_url,
        profilePhotoUrl: r.profile_photo_url,
        rating: r.rating,
        text: r.text,
        relativeTime: r.relative_time_description,
        time: r.time,
      })),
  };
}
